import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RegionsTree, Region } from '../models/Region'

const jsonHttpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class RegionsService {
  private rootURL = '/core-service/api/region';

  constructor(private http: HttpClient) { }

  //tree
  getRegions(): Observable<RegionsTree> {
    return this.http.get<RegionsTree>('/core-service/api/region/tree').pipe(
      catchError(this.handleError<any>('get regions'))
    );
  }

  getAllRegions(): Observable <[Region]>{
    return this.http.get<Region>('core-service/api/region').pipe(
      catchError(this.handleError<any>('get regions')));
  }

  /* merge addRegion and deleteRegion */

  addRegion(region: Region): Observable<RegionsTree> {
    return this.http.post<RegionsTree>('core-service/api/region', JSON.stringify(region), jsonHttpOptions).pipe(
      catchError(this.handleError<any>('add regions'))
    );
  }

  deleteRegion(region: RegionsTree): Observable<any> {
    let url = `${this.rootURL}/${region.region_id}`;
    return this.http.delete(url, jsonHttpOptions).pipe(
      catchError(this.handleError<any>('delete region'))
    );
  }

  updateRegion(region: Region): Observable<RegionsTree> {
    return this.http.post<RegionsTree>('core-service/api/region', JSON.stringify(region), jsonHttpOptions).pipe(
      catchError(this.handleError<any>('update regions'))
    );
  }

  /**
   * Assign the sites to the specified region.
   * Only the site ids is needed.
   * @param region Region that will now have the specified sites.
   * @param siteIds Array of site ids to be added.
   */
  addSitesToRegion(region: Region, siteIds: number[]): Observable<Region> {
    let url = `${this.rootURL}/add/sites`;
    let regionDTO = {region_id: region.region_id, site_ids: siteIds};
    return this.http.put<Region>(url, JSON.stringify(regionDTO), jsonHttpOptions).pipe(
      catchError(this.handleError<any>('add sites to region'))
    )
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
